<template>
  <span class="template icon_fast">
    <svg
      v-if="lang == 'en'"
      width="41"
      height="28"
      viewBox="0 0 41 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 5C0 2.23858 2.23858 0 5 0H36C38.7614 0 41 2.23858 41 5V15C41 17.7614 38.7614 20 36 20H0V5Z"
        fill="url(#paint0_linear_4677_52335)"
      />
      <path
        d="M7.98 5.004H14.77V6.306H9.506V9.218H14.476V10.52H9.506V15H7.98V5.004ZM19.2368 7.566C20.3008 7.566 21.0848 7.832 21.5888 8.364C22.0274 8.83067 22.2468 9.50267 22.2468 10.38V15H20.8748V13.978C20.6041 14.3327 20.2494 14.6267 19.8108 14.86C19.3348 15.084 18.7794 15.196 18.1448 15.196C17.3981 15.196 16.8054 15.0047 16.3668 14.622C15.9188 14.23 15.6948 13.712 15.6948 13.068C15.6948 12.1533 16.0541 11.4767 16.7728 11.038C17.3794 10.6647 18.1728 10.478 19.1528 10.478L20.7768 10.464V10.282C20.7768 9.274 20.2308 8.77 19.1388 8.77C18.6254 8.77 18.2334 8.86333 17.9628 9.05C17.6361 9.26467 17.4448 9.582 17.3888 10.002H15.9188C16.0308 9.14333 16.3948 8.50867 17.0108 8.098C17.5334 7.74333 18.2754 7.566 19.2368 7.566ZM20.7768 11.598L19.2508 11.612C17.8974 11.612 17.2208 12.0833 17.2208 13.026C17.2208 13.3153 17.3281 13.5533 17.5428 13.74C17.7574 13.9267 18.0701 14.02 18.4808 14.02C19.1434 14.02 19.6988 13.8333 20.1468 13.46C20.5668 13.0773 20.7768 12.5827 20.7768 11.976V11.598ZM26.6475 7.566C28.5328 7.566 29.5595 8.32667 29.7275 9.848H28.2855C28.1735 9.456 28.0008 9.18533 27.7675 9.036C27.5155 8.868 27.1328 8.784 26.6195 8.784C26.1528 8.784 25.8168 8.84933 25.6115 8.98C25.3501 9.12 25.2195 9.33467 25.2195 9.624C25.2195 9.86667 25.4155 10.0813 25.8075 10.268C26.0501 10.3707 26.5355 10.5153 27.2635 10.702C28.0755 10.898 28.6868 11.1267 29.0975 11.388C29.6761 11.752 29.9655 12.256 29.9655 12.9C29.9655 14.4307 28.8921 15.196 26.7455 15.196C24.7668 15.196 23.6935 14.3513 23.5255 12.662H24.9815C25.0655 13.1473 25.2381 13.4927 25.4995 13.698C25.7608 13.8847 26.1621 13.978 26.7035 13.978C27.8608 13.978 28.4395 13.6513 28.4395 12.998C28.4395 12.6433 28.2248 12.368 27.7955 12.172C27.5715 12.06 27.0861 11.92 26.3395 11.752C25.4808 11.556 24.8835 11.346 24.5475 11.122C23.9875 10.7673 23.7075 10.282 23.7075 9.666C23.7075 9.00333 23.9781 8.49 24.5195 8.126C25.0608 7.75267 25.7701 7.566 26.6475 7.566ZM33.4169 5.424V7.762H35.0689V8.994H33.4169V13.194C33.4169 13.3807 33.4589 13.5253 33.5429 13.628C33.6362 13.7213 33.7669 13.768 33.9349 13.768H34.8869V15H33.6969C33.0716 15 32.6189 14.8367 32.3389 14.51C32.0682 14.2113 31.9329 13.7727 31.9329 13.194V8.994H30.5889V7.762H31.9329V6.04L33.4169 5.424Z"
        fill="white"
      />
      <path d="M5 20H0L5 28V20Z" fill="#863B3C" />
      <defs>
        <linearGradient
          id="paint0_linear_4677_52335"
          x1="-0.000299962"
          y1="19.9987"
          x2="43.1974"
          y2="10.2715"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF8688" />
          <stop offset="1" stop-color="#E9373E" />
        </linearGradient>
      </defs>
    </svg>
    <svg
      v-else
      width="48"
      height="32"
      viewBox="0 0 48 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 5C0 2.23858 2.23858 0 5 0H43C45.7614 0 48 2.23858 48 5V19C48 21.7614 45.7614 24 43 24H0V5Z"
        fill="url(#paint0_linear_4835_192723)"
      />
      <path
        d="M15.572 7.55H17.966V5.548H19.254V7.55H22.236V11.75H23.202V13.038H19.66C20.5 14.7927 21.7973 16.2207 23.552 17.322L22.656 18.372C20.8827 17.1027 19.562 15.5347 18.694 13.668C18.0313 15.7773 16.8087 17.3407 15.026 18.358L14.214 17.266C15.894 16.3887 17.014 14.9793 17.574 13.038H14.984V11.75H17.84C17.924 11.162 17.966 10.546 17.966 9.902V8.796H15.572V7.55ZM19.254 8.796V9.608C19.254 10.2893 19.2073 11.0033 19.114 11.75H20.948V8.796H19.254ZM11.96 8.334C11.932 9.71533 11.7827 11.05 11.512 12.338L10.434 12.03C10.7233 10.8447 10.8913 9.58933 10.938 8.264L11.96 8.334ZM14.718 7.914C15.0913 8.82867 15.4227 9.86 15.712 11.008L14.648 11.274C14.4147 10.2473 14.1113 9.23 13.738 8.222L14.718 7.914ZM12.408 5.562H13.71V18.386H12.408V5.562ZM28.928 6.57H32.372V5.562H33.618V6.57H37.048V7.774H33.618V8.698H36.6V12.464H33.618V16.594H32.372V13.178C31.672 14.2607 30.6687 15.2127 29.362 16.034L28.536 14.984C29.936 14.2653 30.958 13.4253 31.602 12.464H29.39V8.698H32.372V7.774H28.928V6.57ZM35.382 11.302V9.846H33.618V11.302H35.382ZM32.372 11.302V9.846H30.622V11.302H32.372ZM34.78 12.744C35.6573 13.4627 36.432 14.2 37.104 14.956L36.208 15.838C35.704 15.1567 34.9433 14.396 33.926 13.556L34.78 12.744ZM25.89 5.66C26.8327 6.388 27.6307 7.12533 28.284 7.872L27.346 8.796C26.7767 8.08667 25.988 7.33067 24.98 6.528L25.89 5.66ZM33.926 18.204C33.45 18.204 32.6147 18.1947 31.42 18.176C30.5333 18.1667 29.7913 18.0873 29.194 17.938C28.6433 17.77 28.1533 17.4433 27.724 16.958C27.528 16.7247 27.3507 16.608 27.192 16.608C26.9027 16.608 26.3987 17.238 25.68 18.498L24.7 17.588C25.4 16.4493 26.03 15.74 26.59 15.46V11.498H24.714V10.266H27.836V15.558C27.9107 15.614 27.9807 15.684 28.046 15.768C28.3727 16.1413 28.7087 16.4213 29.054 16.608C29.4927 16.8133 30.1133 16.93 30.916 16.958C31.9613 16.9767 32.904 16.986 33.744 16.986C34.1827 16.986 34.878 16.9767 35.83 16.958C36.446 16.9487 36.9873 16.9253 37.454 16.888L37.132 18.204H33.926Z"
        fill="white"
      />
      <path d="M5.85366 24H0L5.85366 32V24Z" fill="#863B3C" />
      <defs>
        <linearGradient
          id="paint0_linear_4835_192723"
          x1="-0.000351175"
          y1="23.9985"
          x2="50.6904"
          y2="12.8624"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF8688" />
          <stop offset="1" stop-color="#E9373E" />
        </linearGradient>
      </defs>
    </svg>
  </span>
</template>
<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
let store = useStore();
let lang = computed(() => {
  return store.state.lang;
});
</script>
